// -----------------------------------------------------------------Exports---
export default function NotFoundPage(): JSX.Element {
  // --------------------------------------------------------------Return---
  return <>NotFoundPage</>;
}
